export const machineOptions = [
    {
        label: "天鸽",
        value: "天鸽",
    }, {
        label: "天鹅",
        value: "天鹅"
    }, {
        label: "星豚",
        value: "星豚"
    }, {
        label: "天鸽(英文)",
        value: "columba"
    }, {
        label: "天鹅(英文)",
        value: "swan"
    }
] 